import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormGroup, FormBuilder } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <se-po-name
      seFeDataLabel="Name"
      formControlName="name"
      enablePreferred="true"
      enableSuffix="true">
    </se-po-name>
    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit">
        Submit
      </se-fe-button>
    </div>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { Component, OnInit } from '@angular/core'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'

export class PopulatedNameExampleComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {}

  public ngOnInit(): void {
    const name = {
      first: '',
      last: '',
      preferred: '',
      suffix: ''
    }
    this.form = this.fb.group({
      name: [name]
    })
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-populated-name-example',
  template,
  styleUrls: ['../name-docs.component.scss'],
  standalone: false,
})
export class PopulatedNameExampleComponent extends SeFeDocsExampleComponent implements OnInit, OnDestroy {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {
    super()
  }

  public ngOnInit(): void {
    const name = {
      first: 'Ann',
      last: 'Greggs',
      preferred: 'Annie',
      suffix: 'Jr.'
    }
    this.form = this.fb.group({
      name: [name]
    })
  }

  public ngOnDestroy(): void {
    this.seFeToastService.events.next(undefined)
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
